import type { DropData } from './types';

export function isColumnDropTarget(
  drop: DropData | null | undefined,
  rowId: string,
  columnId: string,
): boolean {
  return (
    drop?.kind === 'block-slot' &&
    drop.rowId === rowId &&
    drop.columnId === columnId
  );
}

export function isGroupDropTarget(
  drop: DropData | null | undefined,
  groupId: string,
): boolean {
  return drop?.kind === 'group-row-slot' && drop.groupId === groupId;
}

